// initialize bugsnag as early as possible
import "@/logging";

import React from "react";
import ReactDOM from "react-dom";

import { ErrorBoundary } from "@/logging";
import App from "@/modules/app/components/App";
import "@/modules/theme/utils/fontsource";
import "@/i18n/i18n";

import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
